/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createAppPassword.defs.js'
export * as $defs from './createAppPassword.defs.js'
